// src/utils/platform.js
// Detects whether the app is running inside the Play Store TWA shell or as an
// installed/homescreen PWA, so UI can offer a native-app-like shell there
// without changing anything about the regular website.

export { isAndroid, isIOS } from './inAppBrowser';

// Android sets document.referrer to "android-app://<package>/" when a page is
// opened inside a Trusted Web Activity — the official signal per Google's
// "PWA in Play" codelab that this is the Play Store app, not a browser tab.
export const isTWA = () =>
  typeof document !== 'undefined' && document.referrer.startsWith('android-app://');

// Covers Android/desktop Chrome installed-PWA (display-mode: standalone) and
// iOS Safari "Add to Home Screen" (navigator.standalone).
export const isStandaloneDisplayMode = () =>
  (typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(display-mode: standalone)').matches) ||
  window.navigator.standalone === true;
